<template>
  <div class='upload' v-loading="loading">
    <div class='top'>
      <div class='title-box'>
        <div class='title'>TITLE</div>
        <el-input class="title-input" placeholder='please enter the file title' v-model="fileModel.title"></el-input>
      </div>
      <div class='desc-box'>
        <div class='title'>DESC</div>
        <el-input class="desc-input" placeholder='please enter a file description' type="textarea" v-model="fileModel.desc"></el-input>
      </div>
    </div>
    <div class="select-box">
      <div class='title'>Tag</div>
      <!-- multiple -->
        <el-select
          v-model="fileModel.tags"
          clearable
          placeholder="Select tag"
          class="select"
          @change="selectChange"
        >
          <el-option v-for="tag in $DataString.metricTags" :key="tag" :label="tag" :value="tag"></el-option>
        </el-select>
      </div>
    <div class="bottom">
      <div class="upload-box">
        <img
          class="upload-icon"
          src="@/assets/upload-icon.png"
          @click="$refs.file.click()"
        />
        <input
          ref="file"
          type="file"
          id="fileInput"
          @change="uploadDo($event)"
          style="display: none"
          accept=".json"
          multiple
        />
      </div>
      <div class="upload-content">
        <div class="file-content" v-show="showConfig.showFile" :style="{backgroundColor: fileStyle.backgroundColor}" @mouseenter="mouseFileEnter" @mouseleave="mouseFileLeave">
          <img
            src="@/assets/file-icon.png"
            class="file-icon"
          />
          <div class="upload-file" :style="{color: fileStyle.color}">
            {{ fileModel.fileName }}
          </div>
          <img
            src="@/assets/file-cha.png"
            class="file-cha"
            @click="deleteFile"
            v-show="showConfig.showDeleteFileIcon"
          />
        </div>
        <el-progress
          v-show="showConfig.showProgress"
          class="progress"
          :show-text="showText"
          :percentage="fileModel.percent"
          :color="customColor"
          :status="status"
        ></el-progress>
      </div>
    </div>
    <el-button class="btn" :disabled="disabled" :style="{ backgroundColor: btnBgColor }" @click="confirmDo">confirm</el-button>
  </div>
</template>
<script>
import {
  uploadCrt,
} from "@/utils/common";
import {
  upLoadFile,
  uploadMetricData,
  getUserId,
  addTag
} from "@/request/api";
import { ElMessageBox, ElMessage } from "element-plus";
import {
  ResourceType,
} from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
export default {
  name: 'upload',
  data() {
    return {
      curColor: "#18C5BF",
      status: '',
      showText: false,
      fileStyle: {
        color: '#565656',
        backgroundColor: '#fff'
      },
      showConfig: {
        showProgress: false,
        showFile: false,
        showDeleteFileIcon: false,
      },
      ossClient: null,
      fileModel: {
        title: '',
        desc: '',
        percent: 0,
        fileName: '',
        ossKey: '',
        tags: ''
      },
      loading: false,
    }
  },
  computed: {
    btnBgColor() {
      if (!this.fileModel.title || !this.fileModel.desc || !this.fileModel.tags || this.fileModel.percent == 0) {
        return '#C7C7C7'
      }
      return '#0050b3'
    },
    disabled() {
      if (!this.fileModel.title || !this.fileModel.desc || !this.fileModel.tags || this.fileModel.percent == 0) {
        return true
      }
      return false
    }
  },
  methods: {
    selectChange() {
      console.log(this.fileModel.tags)
    },
    confirmDo() {
      if (!this.fileModel.title || !this.fileModel.desc || this.fileModel.tags.length == 0 || this.fileModel.percent == 0) {
        ElMessage.warning("Please finish editing the information")
        return
      }
      const that = this
      ElMessageBox.confirm(
        'are you sure to upload ?',
        {
          confirmButtonText: "YES",
          cancelButtonText: "NO"
        }
      ).then(
        () => {
          that.uploadDataDo()
          return true
        },
        () => {
          return false
        }
      )
    },
    async uploadDataDo() {
      this.loading = true
      const userId = getUserId()
      const item = {
        userId: userId,
        ossKey: this.fileModel.ossKey,
        title: this.fileModel.title,
        desc: this.fileModel.desc,
        fileName: this.fileModel.fileName,
        bucketName: this.fileModel.bucketName,
        sha1: this.fileModel.sha1,
        tags: [this.fileModel.tags],
        options: this.fileModel.options
      }
      try {
        const upData = await uploadMetricData(item)
        await addTag({ sheetId: upData.dataid, type: ResourceType.DATA, tags: [this.fileModel.tags] })
        ElMessage.success("Upload Successfully")
        setTimeout(() => {
          this.$router.go(0)
        }, 300);
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    stopUploadFile() {
      if (this.ossClient) {
        this.ossClient.cancel()
      }
      this.resetUploadData()
    },
    resetUploadData() {
      this.status = ""
      this.showText = false
      this.showConfig.showProgress = false
      this.showConfig.showFile = false
      this.showConfig.showDeleteFileIcon = false
      this.fileModel.fileName = ""
      this.fileModel.ossKey = ""
      this.fileModel.percent = 0
    },
    resetNomarlData(){
      this.fileModel.title = ""
      this.fileModel.desc = ""
      this.fileModel.tags = ''
    },
    deleteFile() {
      const that = this
      ElMessageBox.confirm(
        `Delete ${this.fileModel.fileName} file ?`
      ).then(
        () => {
          that.stopUploadFile()
          return true
        },
        () => {
          return false
        }
      )
    },
    mouseFileEnter() {
      this.fileStyle.backgroundColor = '#f8f8f8'
      this.fileStyle.color = '#0050b3'
      if (this.fileModel.fileName) {
        this.showConfig.showDeleteFileIcon = true
      }
    },
    mouseFileLeave() {
      this.fileStyle.backgroundColor = '#fff'
      this.fileStyle.color = '#565656'
      this.showConfig.showDeleteFileIcon = false
    },
    async uploadDo(event) {
      this.resetUploadData()
      this.showConfig.showFile = true
      const file = event.target.files[0];
      this.fileModel.fileName = file.name
      const _this = this
      await uploadCrt(file, (osskey) => {     
        _this.fileModel.ossKey = osskey + new Date().getTime()
        upLoadFile(_this.fileModel.ossKey, file, (num, point, ossClient, succ) => {
          console.log(point);
          _this.showConfig.showProgress = true
          if (succ) {
            _this.showText = true
            const progress = num * 100;
            _this.fileModel.percent = progress
            _this.ossClient = ossClient
            _this.fileModel.options = ossClient.options
            if (progress >= 100) {
              _this.status = 'success'
              _this.showConfig.showProgress = false
              _this.ossClient = null
            }
          }  
        });
      })
    },
  },
  created() {
    
  }
}
</script>
<style lang='less' scoped>

.upload {
  background-color: #fff;
  margin-top: 20px;
  width: 800px;
  padding: 30px 20px;
  border-radius: 6px;
}

.top {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.title {
  font-size: 15px;
  color: #565656;
  font-weight: 500;
  width: 150px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 45px;
  width: 100%;
  .title-input {
    width: calc(100% - 150px);
    height: 100%;
    font-size: 14px;
    :deep(.el-input__inner) {
      height: 45px;
    }
  }
}

.desc-box {
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  height: 80px;
  width: 100%;
  .desc-input {
    resize: none;
    font-size: 14px;
    width: calc(100% - 150px);
    :deep(.el-textarea__inner) {
      height: 80px;
      resize: none !important;
    }
  }
}

.select-box {
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  width: 100%;
  .select {
    width: calc(100% - 150px);
  }
}

.bottom {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 20px;
  height: 50px;
  .upload-box {
    width: 150px;
    display: flex;
    justify-content: center;
    .upload-icon {
      margin-top: 2px;
      cursor: pointer;
      height: 35px;
    }
  }

  .upload-content {
    width: calc(100% - 150px);
    height: 100%;
    .file-content {
      height: calc(100% - 10px);
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      .file-icon {
        height: 18px;
        width: 18px;
        object-fit: contain;
      }
      .upload-file {
        height: 100%;
        display: flex;
        align-items: center;
        width: calc(100% - 10px);
        padding: 0px 10px;
        font-size: 15px;
        font-weight: 500;
        color: #565656;
        cursor: pointer;
      }
      .file-cha {
        height: 20px;
        width: 20px;
        cursor: pointer;
      }
    }
    .progress {
      width: 100%;
      height: 20px;
    }
  }
}

.btn {
  background-color: #0050b3;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  width: 120px;
  margin-top: 15px;
}

:deep(.el-progress) {
  font-size: 11px !important;
  height: 6px !important;
}

:deep(.el-select .el-input) {
  height: 45px !important;
  line-height: 45px !important;
}

:deep(.el-select .el-input__wrapper) {
  height: 45px !important;
  line-height: 45px !important;
}

:deep(.el-select .el-tag) {
  color: #383838;
  font-size: 12px;
}


  
</style>